import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";

import { actions as topikActions } from "../../../../modules/topik";
import { draftKey } from "../useDraft";
import SingleTextAnalysisStep from "./SingleTextAnalysisStep";
import AnalysisRecall from "./AnalysisRecall";

// The first analysis stage now captures the risk only; its minimization moved to the
// continue-branch step (§6.2a). The question asks for a risk "that follows from these issues",
// so the issues the player just listed are carried onto the screen (memory-load).
const TopikRiskView = ({ t, session, topikStatus, gameClosed, dispatch }) => (
  <SingleTextAnalysisStep
    t={t}
    title={t("topik-risk-view.title")}
    instruction={t("topik-risk-view.instruction")}
    placeholder={t("topik-risk-view.risk-placeholder")}
    submitLabel={t("topik-risk-view.submit")}
    initialValue={session.risk || ""}
    draftKey={draftKey(session, "risk")}
    maxLength={session.maxTextLength}
    submitting={topikStatus.submitting}
    gameClosed={gameClosed}
    error={topikStatus.error}
    recall={(
      <AnalysisRecall
        entries={[{ key: "issues", label: t("topik-analysis.recall.issues"), list: session.issues }]}
      />
    )}
    assistStep="risk"
    onBack={() => dispatch(topikActions.analysis.back.request())}
    onSubmit={(risk) => dispatch(topikActions.analysis.risk.request({ risk }))}
  />
);

TopikRiskView.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  topikStatus: PropTypes.object.isRequired,
  gameClosed: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

TopikRiskView.defaultProps = {
  gameClosed: false,
};

const mapStateToProps = (state) => ({
  session: state.topik.session,
  topikStatus: state.topik.status,
});

export default compose(withTranslation("views"), connect(mapStateToProps))(TopikRiskView);
